// extracted by mini-css-extract-plugin
export default {"leftAlign":"time-block-module__leftAlign--W_zZD","rightAlign":"time-block-module__rightAlign--Vz54A"};